import React from "react"
import {Link, withPrefix} from 'gatsby';
import Layout from "../../../components/layout";
import SEO from "../../../components/seo"

class CustomProductItemPage extends React.Component {

  render() {
    const {cat, item: { alias, title, url, description }, data: { img, code, content }} = this.props.pageContext;
    const commonLink=`/catalog/cmo`;
    const parentCatLink = `${commonLink}${cat.url}`;
    const pageTitle = `ЦМО: ${title}`;
    // console.log('CustomProductItemPage', this.props.pageContext);

    return <Layout>
      <SEO title={pageTitle} />
      <div id="main" className='catalog'>
        <div className="inner">
          <div className='parent-category'>
            <Link to={parentCatLink}>&larr; {cat.title}</Link>
          </div>
          <h1>{title}</h1>
          <section className='categories'>
            <div className="row">
              <div className="col-4">
                <div className="image fit">
                  <img src={withPrefix(img[0])} alt={code} />
                </div>
                {/*{data.imgExtended[1] && <div className="image fit">*/}
                {/*  <img src={withPrefix(data.imgExtended[1])} alt={data.code} />*/}
                {/*</div>}*/}
                {/*{data.imgExtended[2] && <div className="image fit">*/}
                {/*  <img src={withPrefix(data.imgExtended[2])} alt={data.code} />*/}
                {/*</div>}*/}
              </div>
              <div className="col-8">
                {content[0].title.length > 0 && <h3>{content[0].title}</h3>}
                <div dangerouslySetInnerHTML={{ __html: content[0].content }} />
              </div>
              {content && content.length > 1 && <div className="col-12">
                {content.map((item, j) => {
                  if (j === 0) return null;
                  return <div key={j+item.title}>
                    {item.title.length > 0 && <h3>{item.title}</h3>}
                    <div dangerouslySetInnerHTML={{ __html: item.content }} />
                  </div>
                })}
              </div>}
            </div>
          </section>
        </div>
      </div>
    </Layout>;
  }
}

export default CustomProductItemPage;
